// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H37A","type":"styles_type__3Cjfq","choices":"styles_choices__JI9TV"};